var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhpIcoSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_192_17833",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.287537,
    y: 0.360352,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_192_17833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2875 21.0854V19.0354C15.7875 18.6021 16.9959 17.7688 17.9125 16.5354C18.8292 15.3021 19.2875 13.9021 19.2875 12.3354C19.2875 10.7688 18.8292 9.36878 17.9125 8.13545C16.9959 6.90212 15.7875 6.06878 14.2875 5.63545V3.58545C16.3542 4.05212 18.0375 5.09795 19.3375 6.72295C20.6375 8.34795 21.2875 10.2188 21.2875 12.3354C21.2875 14.4521 20.6375 16.3229 19.3375 17.9479C18.0375 19.5729 16.3542 20.6188 14.2875 21.0854ZM3.28754 15.3604V9.36045H7.28754L12.2875 4.36045V20.3604L7.28754 15.3604H3.28754ZM14.2875 16.3604V8.31045C15.0709 8.67712 15.6834 9.22712 16.125 9.96045C16.5667 10.6938 16.7875 11.4938 16.7875 12.3604C16.7875 13.2105 16.5667 13.9979 16.125 14.7229C15.6834 15.4479 15.0709 15.9938 14.2875 16.3604Z",
    fill: "#FFBE10"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhpIcoSpeaker);
export default __webpack_public_path__ + "static/media/whp-ico-speaker.1b80763ba4dddcef5e51828f2e508337.svg";
export { ForwardRef as ReactComponent };